<template>
  <div>
    <v-card-title
      class="headline pa-0 primary--text mt-9"
      style="word-break: break-word"
    >
      <slot name="titulo" />
    </v-card-title>

    <v-card-text
      v-if="$slots.subtitulo"
      class="px-0 pb-5 pb-md-8 mt-6 primary--text"
    >
      <slot name="subtitulo" />
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'LoginTitulo',
};
</script>
